import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { parseEnrichmentPreviewFieldValue } from "../utils/enrichmentPreview";

export default function EnrichmentPreviewSourceEditor({ ruleDetailData, setRuleDetailData, disabled }) {
  if (ruleDetailData?.sourceFieldDraft === undefined) return null;

  const updateDraft = (draft) => {
    let sourceFieldError = null;
    try {
      parseEnrichmentPreviewFieldValue(draft, ruleDetailData.sourceFieldType);
    } catch (error) {
      sourceFieldError = error.message;
    }
    setRuleDetailData((previous) => ({ ...previous, sourceFieldDraft: draft, sourceFieldError }));
  };

  return (
    <Box mb={2}>
      <TextField
        label="Value from file"
        fullWidth
        multiline
        minRows={2}
        maxRows={8}
        value={ruleDetailData.sourceFieldDraft}
        onChange={(event) => updateDraft(event.target.value)}
        disabled={disabled}
        error={!!ruleDetailData.sourceFieldError}
        helperText={ruleDetailData.sourceFieldError || `Source field: ${ruleDetailData.sourceFieldPath.join(".")}. Edits apply only to this test.`}
        sx={{ "& textarea": { fontFamily: "monospace", fontSize: "0.85rem" } }}
      />
      <Button
        size="small"
        onClick={() => updateDraft(ruleDetailData.originalSourceFieldDraft)}
        disabled={disabled || ruleDetailData.sourceFieldDraft === ruleDetailData.originalSourceFieldDraft}
        sx={{ mt: 0.5, textTransform: "none" }}
      >
        Reset from file
      </Button>
    </Box>
  );
}
